// termdb/handlers/rememberedGvQ.ts
function mayShowRememberedGvQ(opts) {
  const { holder, vocabApi, term, mutationType, skipLabel, callback } = opts;
  holder.style("display", "none").selectAll("*").remove();
  const lst = vocabApi.getGvQLst?.(term) || [];
  if (!lst.length) return false;
  const div = holder.style("display", "block");
  const options = [];
  const addOption = (label, onActivate) => {
    const option = div.append("div").attr("class", "sja_menuoption sja_sharp_border").attr("tabindex", 0).attr("role", "button").text(label).on("click", onActivate).on("keydown", (event) => {
      if (event.key == "Enter" || event.key == " ") {
        event.preventDefault();
        event.target.click();
        return;
      }
      const step = event.key == "ArrowDown" ? 1 : event.key == "ArrowUp" ? -1 : 0;
      if (!step) return;
      const i = options.indexOf(option);
      options[(i + step + options.length) % options.length].node().focus();
      event.preventDefault();
    });
    options.push(option);
    return option;
  };
  const addHeader = () => div.append("div").style("margin-bottom", "5px").style("opacity", 0.65).style("font-size", ".9em").text(`Previously used for ${term.name}`);
  const addRemembered = (entries) => {
    for (const entry of entries) {
      addOption(entry.label, async () => await callback(entry.q)).attr("data-testid", "sjpp-genevariant-rememberedQ");
    }
  };
  const addSkip = () => addOption(skipLabel, async () => await callback());
  const matched = lst.filter((entry) => matchesMutationType(entry.q, mutationType));
  if (matched.length) {
    addHeader();
    addRemembered([...matched, ...lst.filter((entry) => !matched.includes(entry))]);
    addSkip().style("margin-top", "8px");
  } else {
    addSkip();
    addHeader().style("margin-top", "12px");
    addRemembered(lst);
  }
  options[0].node().focus();
  return true;
}
function matchesMutationType(q, mutationType) {
  if (!mutationType) return true;
  if (!mutationType.dts?.length && !Number.isInteger(mutationType.dt)) return false;
  const selected = new Set(
    mutationType.dts?.length ? mutationType.dts.map((dt) => getDtKey(dt)) : [getDtKey(mutationType.dt, mutationType.origin)]
  );
  const filtered = getFilteredDtKeys(q);
  return filtered.size == selected.size && [...filtered].every((key) => selected.has(key));
}
var getDtKey = (dt, origin) => `${dt}|${origin || ""}`;
function getFilteredDtKeys(q) {
  const keys = /* @__PURE__ */ new Set();
  const readFilter = (filter) => {
    for (const item of filter?.lst || []) {
      if (item.type == "tvslst") readFilter(item);
      else if (item.tvs?.term) keys.add(getDtKey(item.tvs.term.dt, item.tvs.term.origin));
    }
  };
  for (const group of q?.customset?.groups || []) readFilter(group.filter);
  return keys;
}

export {
  mayShowRememberedGvQ
};
//# sourceMappingURL=chunk-EEB5VE2A.js.map
